<template>
  <div>
    <div class="mb-4 flex justify-content-between align-items-center">
      <span class="pr-2 mr-2 font-bold text-2xl">Stock Opname</span>
      <div>
        <i class="pi pi-home mr-2"></i>
        <span class="font-small">/ Inventory / Stock Opname</span>
      </div>
    </div>
    <div class="card bg-white">
      <div class="flex justify-content-end mb-2">
        <Button
          icon="pi pi-plus"
          label="Stock Opname"
          class="mr-2"
          @click="$router.push({ name: 'StockOpnameAdd' })"
        />
        <Button
          type="button"
          icon="pi pi-file-export"
          label="Template"
          severity="secondary"
          class="p-button-green mr-2"
          @click="download_pdt_format()"
        />
        
        <!-- <div class="dropdown">
          <Button
          type="button"
          icon="pi pi-file-export"
          label="Template"
          severity="secondary"
          class="p-button-green mr-2"
        />
          <div class="dropdown-content">
            <Menu ref="menu" :model="menuExport" :popup="false" />
          </div>
        </div> -->
        <!-- <Button
          type="button"
          icon="pi pi-file-import"
          label="Import"
          class="mr-2"
          @click="uploadCSV()"
        /> -->
        <Button
          type="button"
          icon="pi pi-refresh"
          label="Reset"
          class="p-button-outlined"
          @click="clearFilter()"
        />
      </div>
      <fx-table
        ref="table"
        :items="items"
        :loading="isLoading"
        :total="totalRecords"
        :grid-options="options"
        :filters="filters"
        @request="onRequestData"
        @sort="onSort($event)"
      >
        <template #columns>
          <Column style="min-width: 3rem; flex: initial" header="" expander>
          </Column>
          <Column
            field="sop_no"
            header="Opname No."
            style="min-width: 12rem"
            :showFilterMenu="false"
            sortable
          >
            <template #filter="{ filterModel, filterCallback }">
              <InputText
                v-model="filterModel.value"
                type="text"
                class="p-column-filter"
                placeholder="Search"
                @keydown.enter="filterCallback()"
              />
            </template>
          </Column>
          <Column
            field="sop_at"
            header="Tgl Opname"
            style="min-width: 12rem"
            :showFilterMenu="false"
            sortable
          >
            <template #body="{ data }">
              {{ formatDate(data.sop_at) }}
            </template>
            <template #filter="{ filterModel, filterCallback }">
              <CalendarFilter
                ref="calendarFilter"
                v-model="filterModel.value"
                showButtonBar
                :numberOfMonths="2"
                @select="filterCallback()"
              />
            </template>
          </Column>
          <Column
            field="whouse"
            header="Gudang/Lokasi"
            style="min-width: 12rem"
            :showFilterMenu="false"
            sortable
          >
            <template #filter="{ filterModel, filterCallback }">
              <InputText
                v-model="filterModel.value"
                type="text"
                class="p-column-filter"
                placeholder="Search"
                @keydown.enter="filterCallback()"
              />
            </template>
          </Column>
          <Column
            field="assignee"
            header="Dihitung Oleh"
            style="min-width: 12rem"
            :showFilterMenu="false"
          >
            <template #filter="{ filterModel, filterCallback }">
              <InputText
                v-model="filterModel.value"
                type="text"
                class="p-column-filter"
                placeholder="Search"
                @keydown.enter="filterCallback()"
              />
            </template>
          </Column>
          <Column
            field="status"
            header="status"
            style="min-width: 12rem"
            :showFilterMenu="false"
            sortable
          >
            <template #body="{ data }">
              <div :class="'status-badge status-' + data.status">
                {{ data.status }}
              </div>
            </template>
            <template #filter="{ filterModel, filterCallback }">
              <Dropdown
                v-model="filterModel.value"
                @change="filterCallback()"
                :options="list_status"
                optionValue="value"
                optionLabel="label"
                class="p-column-filter"
              >
              </Dropdown>
            </template>
          </Column>
          <Column style="flex-grow: 1; justify-content: flex-end">
            <template #body="{ data }">
              <!-- <Button
                v-if="data.status == 'done'"
                type="button"
                icon="pi pi-print"
                class="p-button-outlined p-button-secondary p-button-text mr-2"
                @click="onPrint(data)"
              /> -->
              <Button
                type="button"
                icon="pi pi-pencil"
                class="p-button-outlined p-button-secondary p-button-text mr-2"
                @click="onEditData(data)"
              />
              <Button
                :disabled="data.status == 'done'"
                type="button"
                icon="pi pi-trash"
                class="p-button-outlined p-button-danger p-button-text"
                @click="onConfirmDeletion(data)"
              />
            </template>
          </Column>
        </template>
      </fx-table>
    </div>
    <Dialog
      header="Hapus Stock Opname"
      v-model:visible="dialogHapus"
      :breakpoints="{ '960px': '75vw', '640px': '90vw' }"
      :style="{ width: '50vw' }"
      :modal="true"
    >
      <div class="confirmation-content">
        <span
          >Stock Opname <strong>{{ form.sop_no }}</strong> akan dihapus. Proses
          ?</span
        >
      </div>
      <template #footer>
        <Button
          label="Hapus"
          icon="pi pi-trash"
          @click="onDeleteStockOpname"
          class="p-button-text p-button-danger"
        />
      </template>
    </Dialog>
    <Dialog
      :header="pdfTitle"
      v-model:visible="dialogViewer"
      :breakpoints="{ '960px': '75vw', '640px': '90vw' }"
      :style="{ width: '90vw' }"
      :modal="true"
    >
      <div>
        <embed
          :src="pdfSource"
          type="application/pdf"
          width="100%"
          height="600px"
        />
      </div>
      <template #footer>
        <Button
          type="button"
          label="Download"
          icon="pi pi-download"
          class="p-button-text mr-2"
          @click="onDownloadPdf"
        />
        <Button
          type="button"
          label="Print"
          icon="pi pi-print"
          @click="onPrintPdf"
        />
      </template>
    </Dialog>
    <hotkey :shortcuts="['D']" @triggered="onTriggerHotkey" />
  </div>
</template>

<script>
import PurchaseOrderService from '@/services/PurchaseOrderService'
import StockOpnameService from '@/services/StockOpnameService'
import FxTable from '@/components/inventory/GridSop'
import CalendarFilter from '@/components/CalendarFilter.vue'
import errorHandler from '@/helpers/error-handler'
import Hotkey from '@/components/Hotkey'
import { FilterMatchMode } from 'primevue/api'
import { formatCurrency, formatDate } from '@/helpers/index'
import { saveAs } from 'file-saver'

export default {
  name: 'StockOpname',
  components: {
    CalendarFilter,
    FxTable,
    Hotkey,
  },
  data() {
    return {
      purchaseOrderService: null,
      stockOpnameService: null,
      dialogHapus: false,
      isLoading: false,
      isLoadingSave: false,
      menuExport: [
                  {
                    label: 'Format PDT',                    
                    icon: 'pi pi-mobile',
                    command: () => {
                      this.download_pdt_format()
                    },
                  },
                  {
                    label: 'Format Excel',                    
                    icon: 'pi pi-file-excel',
                    command: () => {
                      this.download_excel_format()
                    },
                  },
                ],
      items: [],
      form: {},
      PurchaseOrder: [],
      StockOpname: [],
      list_status: [
        { value: 'draft', label: 'Draft', level: 0 },
        { value: 'done', label: 'Done', level: 1 },
      ],
      totalRecords: 0,
      options: {
        page: 1,
        rows: 10,
        sortField: 'id',
        sortOrder: -1,
        filters: null,
      },
      filters: {
        sop_no: { value: null, matchMode: FilterMatchMode.CONTAINS },
        sop_at: { value: null, matchMode: FilterMatchMode.CONTAINS },
        whouse: { value: null, matchMode: FilterMatchMode.CONTAINS },
        assignee: { value: null, matchMode: FilterMatchMode.CONTAINS },
        status: { value: null, matchMode: FilterMatchMode.EQUALS },
      },
      pdfSource: '',
      pdfFilename: '',
      pdfTitle: 'PDF Viewer ',
      dialogViewer: false,
    }
  },
  watch: {
    'options.filters'(value) {
      // custom Forcibly delete calendar data because it can't be deleted by default
      if (!value.sop_at.value) {
        this.$refs.calendarFilter.clearValueOnly()
      }
    },
  },
  created() {
    this.purchaseOrderService = new PurchaseOrderService()
    this.stockOpnameService = new StockOpnameService()
  },
  async mounted() {
    this.loadData()
  },
  methods: {
    clearFilter() {
      if (this.$refs.calendarFilter != undefined) {
        this.$refs.calendarFilter.clearValueOnly()
      }
      if (this.$refs.table != undefined) {
        this.$refs.table.initFilters()
      }
    },
    exportTemplate() {
      const data = [{ sku: '', name: '', qty_inv: '', qty_op: 0 }]

      const csvContent = this.convertToCSV(data)
      const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8' })
      const url = URL.createObjectURL(blob)
      const link = document.createElement('a')
      link.href = url
      link.setAttribute('download', 'so_template.csv')
      link.click()
    },
    download_pdt_format() {
      this.stockOpnameService
        .download_pdt_format()
        .then((res) => {
          const url = window.URL.createObjectURL(new Blob([res.data], {type: 'application/vnd.ms-excel'}) )
          const link = document.createElement('a')
          link.href = url
          link.setAttribute('download', 'pdt_format.xlsx')
          document.body.appendChild(link)
          link.click()
        })
        .catch((err) => {
          errorHandler(err, 'Format PDT', this)
        })
    },
    download_excel_format() {
      this.stockOpnameService
        .download_excel_format()
        .then((res) => {
          const url = window.URL.createObjectURL(new Blob([res.data], {type: 'application/vnd.ms-excel'}) )
          const link = document.createElement('a')
          link.href = url
          link.setAttribute('download', 'excel_format.xlsx')
          document.body.appendChild(link)
          link.click()
        })
        .catch((err) => {
          errorHandler(err, 'Format PDT', this)
        })
    },
    convertToCSV(data) {
      const headers = Object.keys(data[0])
      const rows = data.map((obj) => headers.map((header) => obj[header]))
      const headerRow = headers.join(';')
      const csvRows = [headerRow, ...rows.map((row) => row.join(';'))]
      return csvRows.join('\n')
    },
    formatCurrency(val) {
      return formatCurrency(val, 2, 2)
    },
    formatDate(value) {
      return formatDate(value)
    },
    onRequestData(e) {
      this.options = e
      this.loadData()
    },
    loadData() {
      this.isLoading = true
      const page = this.options.page
      const perPage = this.options.rows
      const sortField = this.options.sortField
      const sortOrder = this.options.sortOrder
      const filters = this.options.filters

      this.stockOpnameService
        .paginate(page, perPage, sortField, sortOrder, filters, 'opname')
        .then((res) => {
          this.items = res.data
          this.totalRecords = res.total
          this.isLoading = false
        })
        .catch((err) => {
          errorHandler(err, 'Data Stock Opname', this)
        })
        .finally(() => (this.isLoading = false))
    },
    onSort(e) {
      this.options.value = e
      this.loadData()
    },
    onPrintData(data) {
      this.stockOpnameService
        .print(data.id)
        .then((res) => {
          const url = window.URL.createObjectURL(new Blob([res.data]))
          const link = document.createElement('a')
          link.href = url
          link.setAttribute('download', 'PurchaseOrder.pdf')
          document.body.appendChild(link)
          link.click()
        })
        .catch((err) => {
          errorHandler(err, 'Print Stock Opname', this)
        })
    },
    onDownloadPdf() {
      saveAs(this.pdfSource, this.pdfFilename)
    },
    onPrintPdf() {
      const iframe = document.createElement('iframe')
      iframe.src = this.pdfSource
      iframe.style.display = 'none'
      document.body.appendChild(iframe)

      // Use onload to make pdf preview work on firefox
      iframe.onload = () => {
        iframe.contentWindow.focus()
        iframe.contentWindow.print()
      }
    },
    onPrint(data) {
      this.stockOpnameService
        .print(data.id)
        .then((res) => {
          const blob = new Blob([res.data], { type: 'application/pdf' })
          const pdfUrl = URL.createObjectURL(blob)
          this.pdfSource = pdfUrl + '#toolbar=0'
          this.pdfFilename = 'purchase-order.pdf'
          this.pdfTitle = 'PDF Viewer (' + this.pdfFilename + ')'
          this.dialogViewer = true
        })
        .catch((err) => {
          errorHandler(err, 'Print Stock Opname', this)
        })
    },
    onEditData(data) {
      this.$router.push({
        name: 'StockOpnameEdit',
        params: { id: data.id },
      })
    },

    onConfirmDeletion(data) {
      this.form = data
      this.dialogHapus = true
    },
    onDeleteStockOpname() {
      this.stockOpnameService
        .delete(this.form.id)
        .then((res) => {
          if (res.data.status === 1) {
            this.$toast.add({
              severity: 'success',
              summary: 'Data Stock Opname',
              detail: 'Data berhasil dihapus.',
              life: 3000,
            })
            this.loadData()
          }
        })
        .catch((err) => {
          errorHandler(err, 'Data Stock Opname', this)
        })
      this.form = {}
      this.dialogHapus = false
    },
    onTriggerHotkey(payload) {
      if (payload.keyString === 'D') {
        this.$router.push({ name: 'PurchaseOrderAdd' })
      }
    },
    /* onToggle(value) {
      this.selectedColumns = this.columns.filter((col) => value.includes(col))
    }, */
  },
}
</script>
<style>
.dropdown {
  position: relative;
  display: inline-block;
}

.dropdown-content {
  display: none;
  position: absolute;
  background-color: #f9f9f9;
  min-width: 160px;
  box-shadow: 0px 8px 16px 0px rgba(0,0,0,0.2);
  padding: 0;
  z-index: 100;
}

.dropdown:hover .dropdown-content {
  display: block;
}
</style>